import { combineReducers } from 'redux';
import url from './poster/poster-url';

const poster = combineReducers({
  url,
});

export default poster;



// WEBPACK FOOTER //
// ./src/modules/utils/reducers/poster.reducer.js